"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LRUInMemoryAssignmentCache = exports.NonExpiringInMemoryAssignmentCache = exports.AbstractAssignmentCache = exports.assignmentCacheValueToString = exports.assignmentCacheKeyToString = void 0;
const obfuscation_1 = require("../obfuscation");
const lru_cache_1 = require("./lru-cache");
/** Converts an {@link AssignmentCacheKey} to a string. */
function assignmentCacheKeyToString({ subjectKey, flagKey }) {
    return (0, obfuscation_1.getMD5Hash)([subjectKey, flagKey].join(';'));
}
exports.assignmentCacheKeyToString = assignmentCacheKeyToString;
function assignmentCacheValueToString({ allocationKey, variationKey, }) {
    return (0, obfuscation_1.getMD5Hash)([allocationKey, variationKey].join(';'));
}
exports.assignmentCacheValueToString = assignmentCacheValueToString;
class AbstractAssignmentCache {
    // key -> variation value hash
    constructor(delegate) {
        this.delegate = delegate;
    }
    /** Returns whether the provided {@link AssignmentCacheEntry} is present in the cache. */
    has(entry) {
        return this.get(entry) === assignmentCacheValueToString(entry);
    }
    get(key) {
        return this.delegate.get(assignmentCacheKeyToString(key));
    }
    /**
     * Stores the provided {@link AssignmentCacheEntry} in the cache. If the key already exists, it
     * will be overwritten.
     */
    set(entry) {
        this.delegate.set(assignmentCacheKeyToString(entry), assignmentCacheValueToString(entry));
    }
    /**
     * Returns an array with all {@link AssignmentCacheEntry} entries in the cache as an array of
     * {@link string}s.
     */
    entries() {
        return this.delegate.entries();
    }
}
exports.AbstractAssignmentCache = AbstractAssignmentCache;
/**
 * A cache that never expires.
 *
 * The primary use case is for client-side SDKs, where the cache is only used
 * for a single user.
 */
class NonExpiringInMemoryAssignmentCache extends AbstractAssignmentCache {
    constructor(store = new Map()) {
        super(store);
    }
}
exports.NonExpiringInMemoryAssignmentCache = NonExpiringInMemoryAssignmentCache;
/**
 * A cache that uses the LRU algorithm to evict the least recently used items.
 *
 * It is used to limit the size of the cache.
 *
 * The primary use case is for server-side SDKs, where the cache is shared across
 * multiple users. In this case, the cache size should be set to the maximum number
 * of users that can be active at the same time.
 */
class LRUInMemoryAssignmentCache extends AbstractAssignmentCache {
    constructor(maxSize) {
        super(new lru_cache_1.LRUCache(maxSize));
    }
}
exports.LRUInMemoryAssignmentCache = LRUInMemoryAssignmentCache;
//# sourceMappingURL=abstract-assignment-cache.js.map